import { webComponentsStyleTagTransform } from "@redotech/webpack-css-runtime/web-components";
import STYLE_MANAGER from "../style-manager";

export default webComponentsStyleTagTransform(STYLE_MANAGER);
